export default "__VITE_ASSET__DYN38NnM__"